import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import ClientContainer from '../../ClientContainer';
import BannerStrip from '../../Common/Containers/BannerStrip';
import ConditionsTable from './ConditionsTable';
import ConditionItems from './ConditionItems';
import useCloseDrawers from '../../../hooks/useCloseDrawers';
import useShowDetailsFromDashboard from '../../../hooks/useShowDetailsFromDashboard';
import { RootState } from '../../../../../redux/root';
import { setShowDrawerContent } from '../../../../../redux/slices/generalSlice';
import { ModalDefaultDraggable } from '../../../../../molecules';

const Conditions = () => {
  useCloseDrawers();
  useShowDetailsFromDashboard();
  const dispatch = useDispatch();
  const showDrawerContent = useSelector((s: RootState) => s.general.showDrawerContent);
  const selectedCondition = useSelector((s: RootState) => s.conditions.SelectedCondition);

  const handleClose = () => dispatch(setShowDrawerContent(false));

  // @ts-ignore
  const title = selectedCondition?.namePermitName || 'Permit Conditions';

  return (
    <ClientContainer>
      <BannerStrip label="Conditions" />
      <TableStage>
        <ConditionsTable />
      </TableStage>
      {showDrawerContent && (
        <ModalDefaultDraggable title={title} onClose={handleClose} wide addContactModal>
          <ConditionItems />
        </ModalDefaultDraggable>
      )}
    </ClientContainer>
  );
};

export default Conditions;

const TableStage = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;
